import React, { useMemo } from 'react';
import type { PriceFilterViewModel } from 'autogen/swagger/all';
import ButtonWithActiveState from 'components/Button/ButtonWithActiveState';
import useFilters from '../../../shared/hooks/useFilters';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import { ActiveCount } from '../shared/styles';

export default function PriceFilterMenuOpener({
    model: {
        displayName,
        priceInterval,
        prices,
        isActive,
        queryStringName,
        attribute: { id }
    },
    ...restProps
}: {
    model: PriceFilterViewModel;
}) {
    const activeOptions = useMemo(() => prices.options.filter((option) => option.isSelected).length, [prices.options]);
    const filterMenuId = id.toString();
    const { openFilterMenu } = useFilterMenu(filterMenuId);
    const { toggleFilterByValue } = useFilters();
    const shouldDisplayAsOneOf = prices.options.length === 1 && prices.options[0].displayName === displayName; // if the list of options only has one option and the display name is the same as the Menuitem's display name, it is considered a oneOf

    if (shouldDisplayAsOneOf) {
        return (
            <ButtonWithActiveState
                size="lg"
                isActive={isActive}
                onClick={() => toggleFilterByValue(queryStringName, prices.options[0].value)}
            >
                {displayName}
            </ButtonWithActiveState>
        );
    }

    return (
        <ButtonWithActiveState size="lg" isActive={isActive} onClick={openFilterMenu} {...restProps}>
            {displayName} {!!activeOptions && <ActiveCount>{activeOptions}</ActiveCount>}
        </ButtonWithActiveState>
    );
}
